@if (store.view.ref()) {
  <app-comment-reply #reply
                     [to]="store.view.ref()!"
                     [tags]="replyTags()"
                     (save)="newComments$.next($event)" />
  @if (thread.latest().length) {
    <app-comment-thread [source]="store.view.url()"
                        [newComments$]="newComments$"
                        [scrollToLatest]="true"
                        [depth]="depth()" />
    @if (thread.hasMore()) {
      <span class="fake-link load-more" (click)="thread.loadMore()" i18n>
      load more comments
    </span>
    }
  } @else {
    <app-loading />
  }
} @else {
  <app-loading />
}
